// extracted by mini-css-extract-plugin
export default {"work-flow":"WorkFlow_work-flow__39uqR","dropdown":"WorkFlow_dropdown__Xwzz7","loader-container":"WorkFlow_loader-container__cDvbA"};